export const LEVEL = '/level/'
export const LEVEL_ALL = `${LEVEL}all`
